import { PercentPipe } from './percent.pipe';
import { Pipe, PipeTransform, Injectable } from '@angular/core';
import { ColorEnum, Default, Utils } from '../utils';
/**
 *  [innerHTML]="[ value | trPercentSignusColor ]"
 */

@Pipe({ name: 'trPercentSignusColorParenth' })
@Injectable({ providedIn: 'root' })
export class PercentSignusColorParenthPipe implements PipeTransform {
  constructor(private percentPipe: PercentPipe) {}

  transform(value: number, digitsInfo?: string): string {
    if (!Utils.isValue(value)) return '--';

    let num = this.percentPipe.transform(value, digitsInfo);

    const color =
      value === 0
        ? ColorEnum.neutro
        : value > 0
        ? ColorEnum.positive
        : ColorEnum.negative;

    const txt = Default.templateSpanParentheses;

    if (value > 0) {
      num = '+' + num;
    }

    return Utils.formatString(txt, [color, num]);
  }
}
